// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /memories/events/:eventId — manage dashboard theme */
.memories-event-manage-page {
  --mem-bg: #f6f4fb;
  --mem-surface: #ffffff;
  --mem-surface-muted: #ffffff;
  --mem-text: #0f172a;
  --mem-text-muted: #475569;
  --mem-text-faint: #64748b;
  --mem-border: #e2e8f0;
  --mem-accent: #7c3aed;
  --mem-accent-soft: #f5f3ff;
}

html.dark .memories-event-manage-page {
  --mem-bg: #020617;
  --mem-surface: #1e293b;
  --mem-surface-muted: #0f172a;
  --mem-text: #f1f5f9;
  --mem-text-muted: #cbd5e1;
  --mem-text-faint: #94a3b8;
  --mem-border: #475569;
  --mem-accent: #a78bfa;
  --mem-accent-soft: #2e1065;
}

.memories-event-manage-page {
  width: 100%;
  min-height: calc(100dvh - 4.25rem);
  min-height: calc(100vh - 4.25rem);
  background-color: var(--mem-bg);
  color: var(--mem-text);
}

.memories-event-manage-page .me-manage-inner {
  width: 100%;
  max-width: 64rem;
  margin-inline: auto;
  padding: clamp(1rem, 3vw, 2rem) clamp(0.75rem, 3vw, 1.5rem) clamp(2rem, 5vw, 5rem);
}

.memories-event-manage-page .me-manage-back {
  color: var(--mem-text-faint);
}

.memories-event-manage-page .me-manage-back:hover {
  color: var(--mem-accent);
}

.memories-event-manage-page .me-manage-header,
.memories-event-manage-page .me-manage-panel {
  background-color: color-mix(in srgb, var(--mem-surface) 88%, transparent);
  border: 1px solid var(--mem-border);
  color: var(--mem-text);
}

.memories-event-manage-page .me-manage-title {
  color: var(--mem-text);
}

.memories-event-manage-page .me-manage-muted {
  color: var(--mem-text-muted);
}

.memories-event-manage-page .me-manage-faint {
  color: var(--mem-text-faint);
}

.memories-event-manage-page .me-manage-body {
  color: var(--mem-text-muted);
}

.memories-event-manage-page .me-manage-chip {
  background-color: color-mix(in srgb, var(--mem-surface) 95%, transparent);
  border: 1px solid var(--mem-border);
  color: var(--mem-text-muted);
}

.memories-event-manage-page .me-manage-chip-privacy {
  background-color: color-mix(in srgb, var(--mem-accent-soft) 90%, transparent);
  border: 1px solid color-mix(in srgb, var(--mem-accent) 35%, var(--mem-border));
  color: var(--mem-accent);
}

html.dark .memories-event-manage-page .me-manage-chip-privacy {
  color: #e9d5ff;
}

.memories-event-manage-page .me-manage-chip-photos {
  background-color: var(--mem-surface-muted);
  border: 1px solid var(--mem-border);
  color: var(--mem-text-muted);
}

.memories-event-manage-page .me-manage-chip-photos svg {
  color: var(--mem-text-faint);
}

.memories-event-manage-page .me-manage-gallery-scroll {
  background-color: var(--mem-surface-muted);
  border: 1px solid var(--mem-border);
}

.memories-event-manage-page .me-manage-gallery-empty {
  background: linear-gradient(
    to bottom,
    color-mix(in srgb, var(--mem-surface-muted) 80%, transparent),
    var(--mem-surface)
  );
  border: 1px dashed var(--mem-border);
  color: var(--mem-text-muted);
}

.memories-event-manage-page .me-manage-qr-wrap {
  background: linear-gradient(
    to bottom,
    var(--mem-surface),
    var(--mem-surface-muted)
  );
  border: 1px solid var(--mem-border);
}

.memories-event-manage-page .me-manage-btn-outline {
  background-color: var(--mem-surface);
  border: 1px solid var(--mem-border);
  color: var(--mem-text);
}

.memories-event-manage-page .me-manage-btn-outline:hover {
  border-color: color-mix(in srgb, var(--mem-accent) 40%, var(--mem-border));
  background-color: var(--mem-surface-muted);
}

.memories-event-manage-page .me-manage-btn-violet {
  background-color: color-mix(in srgb, var(--mem-accent-soft) 85%, transparent);
  border: 1px solid color-mix(in srgb, var(--mem-accent) 30%, var(--mem-border));
  color: var(--mem-text);
}

html.dark .memories-event-manage-page .me-manage-btn-violet {
  color: #ede9fe;
}

.memories-event-manage-page .me-manage-btn-violet:hover {
  background-color: color-mix(in srgb, var(--mem-accent-soft) 100%, transparent);
}

.memories-event-manage-page .me-manage-icon-box {
  background: linear-gradient(135deg, #ede9fe, #fae8ff);
  border: 1px solid color-mix(in srgb, var(--mem-accent) 25%, var(--mem-border));
}

html.dark .memories-event-manage-page .me-manage-icon-box {
  background: linear-gradient(135deg, #4c1d95, #701a75);
  border-color: #6b21a8;
}

.memories-event-manage-page .me-manage-icon-box svg,
.memories-event-manage-page .me-manage-icon-box .text-violet-600 {
  color: var(--mem-accent);
}

.memories-event-manage-page .me-manage-loading-empty {
  border: 1px dashed color-mix(in srgb, var(--mem-accent) 35%, var(--mem-border));
  background-color: color-mix(in srgb, var(--mem-accent-soft) 40%, transparent);
}

.memories-event-manage-page .me-manage-state-shell {
  background-color: var(--mem-surface);
  border: 1px solid var(--mem-border);
  color: var(--mem-text-muted);
}

.memories-event-manage-page .me-manage-label {
  color: var(--mem-text-faint);
}

.memories-event-manage-page .me-manage-share-pending {
  border: 1px dashed color-mix(in srgb, var(--mem-accent) 45%, var(--mem-border));
  background-color: color-mix(in srgb, var(--mem-accent-soft) 70%, transparent);
  color: var(--mem-text-muted);
}

.memories-event-manage-page .me-manage-cover {
  background-color: var(--mem-surface-muted);
  border: 1px solid var(--mem-border);
}
`, "",{"version":3,"sources":["webpack://./src/pages/memories/memories-event-manage-page.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,yEAAyE;EACzE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yEAAyE;EACzE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,6EAA6E;EAC7E,8EAA8E;EAC9E,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE;;;;GAIC;EACD,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE;;;;GAIC;EACD,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,0EAA0E;EAC1E,0CAA0C;AAC5C;;AAEA;EACE,6EAA6E;EAC7E,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,qDAAqD;EACrD,8EAA8E;AAChF;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,+EAA+E;EAC/E,6EAA6E;AAC/E;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+EAA+E;EAC/E,6EAA6E;EAC7E,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC","sourcesContent":["/* /memories/events/:eventId — manage dashboard theme */\n.memories-event-manage-page {\n  --mem-bg: #f6f4fb;\n  --mem-surface: #ffffff;\n  --mem-surface-muted: #ffffff;\n  --mem-text: #0f172a;\n  --mem-text-muted: #475569;\n  --mem-text-faint: #64748b;\n  --mem-border: #e2e8f0;\n  --mem-accent: #7c3aed;\n  --mem-accent-soft: #f5f3ff;\n}\n\nhtml.dark .memories-event-manage-page {\n  --mem-bg: #020617;\n  --mem-surface: #1e293b;\n  --mem-surface-muted: #0f172a;\n  --mem-text: #f1f5f9;\n  --mem-text-muted: #cbd5e1;\n  --mem-text-faint: #94a3b8;\n  --mem-border: #475569;\n  --mem-accent: #a78bfa;\n  --mem-accent-soft: #2e1065;\n}\n\n.memories-event-manage-page {\n  width: 100%;\n  min-height: calc(100dvh - 4.25rem);\n  min-height: calc(100vh - 4.25rem);\n  background-color: var(--mem-bg);\n  color: var(--mem-text);\n}\n\n.memories-event-manage-page .me-manage-inner {\n  width: 100%;\n  max-width: 64rem;\n  margin-inline: auto;\n  padding: clamp(1rem, 3vw, 2rem) clamp(0.75rem, 3vw, 1.5rem) clamp(2rem, 5vw, 5rem);\n}\n\n.memories-event-manage-page .me-manage-back {\n  color: var(--mem-text-faint);\n}\n\n.memories-event-manage-page .me-manage-back:hover {\n  color: var(--mem-accent);\n}\n\n.memories-event-manage-page .me-manage-header,\n.memories-event-manage-page .me-manage-panel {\n  background-color: color-mix(in srgb, var(--mem-surface) 88%, transparent);\n  border: 1px solid var(--mem-border);\n  color: var(--mem-text);\n}\n\n.memories-event-manage-page .me-manage-title {\n  color: var(--mem-text);\n}\n\n.memories-event-manage-page .me-manage-muted {\n  color: var(--mem-text-muted);\n}\n\n.memories-event-manage-page .me-manage-faint {\n  color: var(--mem-text-faint);\n}\n\n.memories-event-manage-page .me-manage-body {\n  color: var(--mem-text-muted);\n}\n\n.memories-event-manage-page .me-manage-chip {\n  background-color: color-mix(in srgb, var(--mem-surface) 95%, transparent);\n  border: 1px solid var(--mem-border);\n  color: var(--mem-text-muted);\n}\n\n.memories-event-manage-page .me-manage-chip-privacy {\n  background-color: color-mix(in srgb, var(--mem-accent-soft) 90%, transparent);\n  border: 1px solid color-mix(in srgb, var(--mem-accent) 35%, var(--mem-border));\n  color: var(--mem-accent);\n}\n\nhtml.dark .memories-event-manage-page .me-manage-chip-privacy {\n  color: #e9d5ff;\n}\n\n.memories-event-manage-page .me-manage-chip-photos {\n  background-color: var(--mem-surface-muted);\n  border: 1px solid var(--mem-border);\n  color: var(--mem-text-muted);\n}\n\n.memories-event-manage-page .me-manage-chip-photos svg {\n  color: var(--mem-text-faint);\n}\n\n.memories-event-manage-page .me-manage-gallery-scroll {\n  background-color: var(--mem-surface-muted);\n  border: 1px solid var(--mem-border);\n}\n\n.memories-event-manage-page .me-manage-gallery-empty {\n  background: linear-gradient(\n    to bottom,\n    color-mix(in srgb, var(--mem-surface-muted) 80%, transparent),\n    var(--mem-surface)\n  );\n  border: 1px dashed var(--mem-border);\n  color: var(--mem-text-muted);\n}\n\n.memories-event-manage-page .me-manage-qr-wrap {\n  background: linear-gradient(\n    to bottom,\n    var(--mem-surface),\n    var(--mem-surface-muted)\n  );\n  border: 1px solid var(--mem-border);\n}\n\n.memories-event-manage-page .me-manage-btn-outline {\n  background-color: var(--mem-surface);\n  border: 1px solid var(--mem-border);\n  color: var(--mem-text);\n}\n\n.memories-event-manage-page .me-manage-btn-outline:hover {\n  border-color: color-mix(in srgb, var(--mem-accent) 40%, var(--mem-border));\n  background-color: var(--mem-surface-muted);\n}\n\n.memories-event-manage-page .me-manage-btn-violet {\n  background-color: color-mix(in srgb, var(--mem-accent-soft) 85%, transparent);\n  border: 1px solid color-mix(in srgb, var(--mem-accent) 30%, var(--mem-border));\n  color: var(--mem-text);\n}\n\nhtml.dark .memories-event-manage-page .me-manage-btn-violet {\n  color: #ede9fe;\n}\n\n.memories-event-manage-page .me-manage-btn-violet:hover {\n  background-color: color-mix(in srgb, var(--mem-accent-soft) 100%, transparent);\n}\n\n.memories-event-manage-page .me-manage-icon-box {\n  background: linear-gradient(135deg, #ede9fe, #fae8ff);\n  border: 1px solid color-mix(in srgb, var(--mem-accent) 25%, var(--mem-border));\n}\n\nhtml.dark .memories-event-manage-page .me-manage-icon-box {\n  background: linear-gradient(135deg, #4c1d95, #701a75);\n  border-color: #6b21a8;\n}\n\n.memories-event-manage-page .me-manage-icon-box svg,\n.memories-event-manage-page .me-manage-icon-box .text-violet-600 {\n  color: var(--mem-accent);\n}\n\n.memories-event-manage-page .me-manage-loading-empty {\n  border: 1px dashed color-mix(in srgb, var(--mem-accent) 35%, var(--mem-border));\n  background-color: color-mix(in srgb, var(--mem-accent-soft) 40%, transparent);\n}\n\n.memories-event-manage-page .me-manage-state-shell {\n  background-color: var(--mem-surface);\n  border: 1px solid var(--mem-border);\n  color: var(--mem-text-muted);\n}\n\n.memories-event-manage-page .me-manage-label {\n  color: var(--mem-text-faint);\n}\n\n.memories-event-manage-page .me-manage-share-pending {\n  border: 1px dashed color-mix(in srgb, var(--mem-accent) 45%, var(--mem-border));\n  background-color: color-mix(in srgb, var(--mem-accent-soft) 70%, transparent);\n  color: var(--mem-text-muted);\n}\n\n.memories-event-manage-page .me-manage-cover {\n  background-color: var(--mem-surface-muted);\n  border: 1px solid var(--mem-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
